<script setup>
import { ref, nextTick, onMounted, watch, watchEffect } from "vue";

const props = defineProps(["icon", "title", "value"]);
const open = ref(false);
const root = ref(null);

watchEffect(() => {
	open.value = !props.value;
});

watch(open, () => {
	if (open.value)
		nextTick(() => scroll());
});

onMounted(() => {
	if (open.value && (!navigator.userActivation || navigator.userActivation.hasBeenActive))
		scroll();
});

function scroll() {
	if (root.value)
		root.value.scrollIntoView({ behavior: "smooth", block: "start" });
}
</script>

<template>
	<div ref="root" class="accordion elevated">
		<div class="header grid gap-16 align-items-center" @click="open = !open">
			<i class="icon fa-solid fa-fw" :class="icon"></i>
			<div class="header-content grid col-gap-16 align-items-center">
				<div class="title"><slot name="title">{{ title }}</slot></div>
				<div class="value">{{ value }}</div>
			</div>
			<i class="caret fa-solid fa-fw fa-caret-down" :class="{ open }"></i>
		</div>
		<div v-if="open" class="content">
			<slot></slot>
		</div>
	</div>
</template>
